import './utils/imagePreloader'; // Load this first to start preloading before React
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { EditryProvider } from '@lazylabs-dev/editry-react';
import { EDITRY_CONFIG } from './utils/editryConfig';

const AppWithScrollbar = () => {
  return (
    <div>
      <App/>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EditryProvider
      config={EDITRY_CONFIG}
      persistAdminSession={true}
      initialOverlayEnabled={false}
    >
      <Router>
        <AppWithScrollbar/>
      </Router>
    </EditryProvider>
  </React.StrictMode>
);

reportWebVitals();
